import './index.css';
import { getValueFromDom, storeValueInDom } from '@hh.ru/magritte-common-dom-storage';

var styles = {"no-scroll":"magritte-no-scroll___fxal2_1-2-7","noScroll":"magritte-no-scroll___fxal2_1-2-7","no-overscroll":"magritte-no-overscroll___LJuvL_1-2-7","noOverscroll":"magritte-no-overscroll___LJuvL_1-2-7"};

let scrollbarWidth = null;
const hasScrollbar = () => document.body.offsetWidth > document.body.clientWidth;
const getScrollbarWidth = () => {
    if (scrollbarWidth !== null) {
        return hasScrollbar() ? scrollbarWidth : 0;
    }
    const scrollContainer = document.createElement('div');
    scrollContainer.style.visibility = 'hidden';
    scrollContainer.style.overflow = 'scroll';
    document.body.appendChild(scrollContainer);
    const scrollContent = document.createElement('div');
    scrollContainer.appendChild(scrollContent);
    scrollbarWidth = scrollContainer.offsetWidth - scrollContent.offsetWidth;
    document.body.removeChild(scrollContainer);
    return hasScrollbar() ? scrollbarWidth : 0;
};
const toNumber = (value) => {
    const num = parseInt(value, 10);
    return Number.isInteger(num) ? num : 0;
};
const STORAGE_NAME = '_MAGRITTE_MODAL_HELPER_';
const getState = () => {
    const state = getValueFromDom(STORAGE_NAME);
    if (state === undefined) {
        return {
            enableFunc: () => undefined,
            modalsCount: 0,
        };
    }
    return state;
};
const storeState = (state) => {
    storeValueInDom(STORAGE_NAME, state);
};
const addToStateDecorator = (enableFuncFactory) => {
    const state = getState();
    state.modalsCount += 1;
    storeState(state);
    if (state.modalsCount > 1) {
        return state.enableFunc;
    }
    state.enableFunc = enableFuncFactory();
    storeState(state);
    return state.enableFunc;
};
const removeFromStateDecorator = (enableFuncCallback) => {
    const state = getState();
    state.modalsCount = Math.max(state.modalsCount - 1, 0);
    storeState(state);
    if (state.modalsCount > 0) {
        return;
    }
    enableFuncCallback();
};
const disableOverscroll = () => {
    return addToStateDecorator(() => {
        if (visualViewport === null) {
            return () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
        }
        document.body.classList.add(styles.noOverscroll);
        document.documentElement.classList.add(styles.noOverscroll);
        return () => {
            removeFromStateDecorator(() => {
                document.body.classList.remove(styles.noOverscroll);
                document.documentElement.classList.remove(styles.noOverscroll);
            });
        };
    });
};
const disableScroll = () => {
    return addToStateDecorator(() => {
        if (visualViewport === null) {
            return () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
        }
        const scrollPosition = visualViewport.pageTop;
        const marginTopBefore = document.body.style.marginTop;
        document.body.style.marginTop = `${Math.round(toNumber(marginTopBefore) - scrollPosition)}px`;
        const paddingRightBefore = document.body.style.paddingRight;
        document.body.style.paddingRight = `${Math.round(toNumber(paddingRightBefore) + getScrollbarWidth())}px`;
        document.body.classList.add(styles.noScroll);
        document.documentElement.classList.add(styles.noScroll);
        return () => {
            removeFromStateDecorator(() => {
                document.body.style.marginTop = marginTopBefore;
                document.body.style.paddingRight = paddingRightBefore;
                document.body.classList.remove(styles.noScroll);
                document.documentElement.classList.remove(styles.noScroll);
                if (scrollPosition !== null) {
                    window.scrollTo(0, Math.round(scrollPosition));
                }
            });
        };
    });
};

export { disableOverscroll, disableScroll };
//# sourceMappingURL=index.js.map
